import React, { useEffect } from 'react';
import { themeOptions } from './theme/theme';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider, responsiveFontSizes } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
  useLocation,
} from 'react-router-dom';

import { Navbar } from '@navigationMenu/Navbar';
import { Footer } from '@navigationMenu/Footer';
import { routes } from '@navigation/routes';
import { ZustandConsumer, ZustandProvider } from '@store/modalStore';
import { datadogRum } from '@datadog/browser-rum';

let theme = createTheme(themeOptions);
theme = responsiveFontSizes(theme);
const queryClient = new QueryClient();

const useStyles = makeStyles({
  content: {
    width: '100%',
    overflow: 'auto',
  },
});

// Componente para rastrear cambios de rutas y configurar el contexto global de Datadog
const TrackRouteChanges = () => {
  const location = useLocation();

  useEffect(() => {
    datadogRum.setGlobalContext({ currentPath: location.pathname });
    datadogRum.startView(location.pathname);
  }, [location]);

  return null;
};

export const App: React.FC = () => {
  const classes = useStyles();

  useEffect(() => {
    // Inicializar Datadog RUM
    datadogRum.init({
      applicationId: 'fb53b9c7-03d1-4b82-a653-fffb8e955e4d',
      clientToken: 'pubdda1aa3b856f78049a7270516fbbf4ba',
      site: 'us5.datadoghq.com',
      service: 'test_cocheseguro_qa',
      env: 'qa',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      allowedTracingUrls: ['https://inter-cocheseguro-qa.web.app','https://demos.inter.mx'],
      defaultPrivacyLevel: 'mask-user-input',
      trackUserInteractions: true,// Activa el rastreo de interacciones
      trackResources:true,
      trackLongTasks: true,
      trackViewsManually: true,
    });

    // Inicia una vista inicial
   // console.log("Init->",datadogRum)
    datadogRum.startView({ name:window.location.pathname, version: '1.0.1'});
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ZustandProvider>
        <Router>
          <div>
            <ThemeProvider theme={theme}>
              <Navbar />
              <ZustandConsumer />

              {/* Componente para rastrear rutas */}
              <TrackRouteChanges />

              <main className={classes.content}>
                <Switch>
                  {routes.map(({ exact, path, component }, i) => (
                    <Route
                      key={i}
                      exact={exact}
                      path={path}
                      // @ts-ignore
                      component={component}
                    />
                  ))}
                  <Redirect to={'/'} />
                </Switch>
              </main>
              <Footer />
            </ThemeProvider>
          </div>
        </Router>
      </ZustandProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
